import React from 'react';

/**
 * KPI tile for dashboard strips.
 * @param {'default' | 'primary' | 'compact'} size
 */
export default function DashboardKpi({
  label,
  value,
  hint,
  accent = false,
  size = 'default',
  className = '',
  children,
}) {
  const isCompact = size === 'compact';
  const isPrimary = size === 'primary';

  return (
    <div
      className={[
        'relative overflow-hidden rounded-lg border border-dark-border bg-dark-card/90',
        'transition-colors duration-200 hover:border-primary/40',
        'animate-fade-in',
        isCompact ? 'p-2.5' : isPrimary ? 'p-4' : 'p-3.5',
        className,
      ].join(' ')}
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent"
        aria-hidden
      />
      <p
        className={[
          'text-dark-text-secondary mb-1 truncate',
          isCompact ? 'text-[10px] leading-tight' : 'text-xs',
        ].join(' ')}
      >
        {label}
      </p>
      <p
        className={[
          'font-semibold truncate',
          accent || isPrimary ? 'text-primary' : 'text-dark-text',
          isCompact ? 'text-base' : isPrimary ? 'text-2xl sm:text-3xl' : 'text-2xl',
        ].join(' ')}
      >
        {value}
      </p>
      {hint && (
        <p className="mt-1 truncate text-xs text-dark-text-muted" title={hint}>
          {hint}
        </p>
      )}
      {children}
    </div>
  );
}
